import { AppMachineContext } from '@/components/Functional/hooks-core/useRaundLifeCycle'
import { Debug } from '@/components/Models/debug'
import { useTokenStore } from '@/store/useTokenStore'
import { useSelector } from '@xstate/react'

export const RaundLifeCycleDebug = () => {
  const appActorRef = AppMachineContext.useActorRef()
  const isLoginQuestionnaireExists = useSelector(appActorRef, (s) => s.context.isLoginQuestionnaireExists)
  const isShowingQuestionnaire = useSelector(appActorRef, (s) =>
    s.matches({ phase3: { flow: 'showingQuestionnaire' } }),
  )
  const isLoginQuestionnaireAnsweredByUser = useSelector(
    appActorRef,
    (s) => s.context.isLoginQuestionnaireAnsweredByUser,
  )
  const isConfirmModalExists = useSelector(appActorRef, (s) => s.context.isConfirmModalExists)
  const isShowingConfirm = useSelector(appActorRef, (s) => s.matches({ phase3: { flow: 'showingConfirm' } }))
  const stateMachineValue = useSelector(appActorRef, (s) => s.value)
  const { idToken, loading } = useTokenStore()

  return (
    <>
      {process.env.NODE_ENV !== 'production' && (
        <Debug
          title={'raund-life-cycle'}
          text={[
            `- 1. isLoginQuestionnaireExists:=${isLoginQuestionnaireExists}`,
            `- 2. isLoginQuestionnaireAnsweredByUser:=${isLoginQuestionnaireAnsweredByUser}`,
            `- 3. isConfirmModalExists:=${isConfirmModalExists}`,
            `- isShowingQuestionnaire:=${isShowingQuestionnaire}`,
            `- isShowingConfirmPopup:=${isShowingConfirm}`,
            `- stateMachineValue:=${JSON.stringify(stateMachineValue)}`,
            `- loading:=${loading}`,
            `- idToken:=${idToken}`,
          ]}
        />
      )}
    </>
  )
}
